
export const invoicingHelper = {
    methods: {
        getContractText(data) {
            // TODO - Clean this up once backend data update is done!
            if (data.contract) {
                return data.contract.id + ' - ' + data.contract.name
            }
            if (data.invoice_summaries && data.invoice_summaries.length > 0) {
                return data.invoice_summaries[0].contract_id + ' - ' + data.contract_name
            }
            return data.contract_id + ' - ' + data.contract_name
        },
        getStatusText(status) {
            switch (status) {
                case 2:
                    return this.$t('invoice_history.in_progress')
                case 3:
                    return this.$t('invoice_history.paid')
                case 4:
                    return this.$t('invoice_history.rejected')
                default:
                    return this.$t('invoice_history.draft')
            }
        },
        formatDate(value) {
            if (!value) return '-'
            // If backend returns timestamps or ISO strings, normalize
            const d = new Date(value)
            if (isNaN(d)) return value
            // Finnish date format dd.mm.yyyy
            return d.toLocaleDateString('fi-FI')
        },
        formatCurrency(sum) {
            if (sum === null || sum === undefined) return '-'
            const n = Number(sum) || 0
            return new Intl.NumberFormat('fi-FI', {style: 'currency', currency: 'EUR'}).format(n)
        },
        formatGrossAmount(value) {
            if (value === null || value === undefined || value === '') return '-'
            return this.formatCurrency(value)
        },
        statusClass(statusCode) {
            switch (statusCode) {
                case 3:
                    return 'status-badge status-paid'
                case 2:
                    return 'status-badge status-in-progress'
                case 4:
                    return 'status-badge status-failed'
                default:
                    return 'status-badge status-default'
            }
        },
        getCreditRowOrder(creditRow, invoice) {
            return this.getInvoiceRowOrder(creditRow.invoice_row_id, invoice)
        },

        getInvoiceRowOrder(invoiceRowId, invoice) {
            const invoiceRow = invoice.invoice_rows?.find(row => row.id === invoiceRowId)
            if (invoiceRow) {
                if (invoiceRow.items && invoiceRow.items.length > 0) {
                    return invoiceRow.items[0].order?.id + ' - ' + invoiceRow.items[0].order?.task_type?.name
                }
            }
            return ""
        },

        getInvoiceItemOrder(itemId, invoice) {
            let result = null
            for (const invoiceRow of this.invoice.invoice_rows) {
                if (invoiceRow.items?.length) {
                    const item = invoiceRow.items.find(itm => itm.id === itemId)
                    if (item) {
                        result = `${item.order?.id} - ${item.order?.task_type?.name}`
                        break
                    }
                }
            }
            return result
        },

        getInvoiceRowDates(rowId, invoice) {
            const row = invoice.invoice_rows.find(r => r.id === rowId)
            if (row && row.items && row.items.length > 0) {
                let start, end
                row.items.forEach(item => {
                    const date = new Date(item.date)
                    if (!start || date.getTime() < start.getTime()) {
                        start = date
                    }
                    if (!end || date.getTime() > end.getTime()) {
                        end = date
                    }
                })
                return this.formatDate(start) + ' - ' + this.formatDate(end)
            }
            return ''
        },
        getInvoiceRowAmount(rowId, invoice) {
            let amount = 0
            const data = invoice.invoice_rows.find(r => r.id === rowId)
            data.items.forEach(item => {
                amount += item.invoiceable_amount ?? item.invoice_amount ?? 0
            })
            return amount.toFixed(2)
        },
        getInvoiceRowSum(rowId, invoice) {
            let sum = 0
            const data = invoice.invoice_rows.find(r => r.id === rowId)
            data.items.forEach(item => {
                sum += (item.invoiceable_sum == null || item.invoiceable_sum === 0) ? (item.cost ?? 0) : item.invoiceable_sum
            })
            return sum
        },
        getInvoiceRowUnitPrice(id, invoice) {
            const row = invoice.invoice_rows.find(r => r.id === id)
            if (row && row.items && row.items.length > 0) {
                return row.items[0].unit_price
            }
            return null
        },

        getInvoiceRowUnit(id, invoice) {
            const row = invoice.invoice_rows.find(r => r.id === id)
            if (row && row.items && row.items.length > 0) {
                return this.pricingModelToText(row.items[0].pricing_model)
            }
            return ''
        },

        getInvoiceRowAccount(id, invoice) {
            const row = invoice.invoice_rows.find(r => r.id === id)
            if (row && row.items && row.items.length > 0) {
                return row.items[0].order?.account?.code + ' - ' + row.items[0].order?.account?.name
            }
            return ''
        },

        getInvoiceRowInvoicingCode(id, invoice) {
            const row = this.invoice.invoice_rows.find(r => r.id === id)
            if (row && row.items && row.items.length > 0) {
                return row.items[0].order?.invoicing_code?.code + ' - ' + row.items[0].order?.invoicing_code?.name
            }
            return ''
        },

        getInvoiceAmount(row) {
            return row.invoiceable_amount ? row.invoiceable_amount.toFixed(2) : row.invoice_amount ? row.invoice_amount.toFixed(2) : ''
        },

        getWorkTimeRange(invoice) {
            let range = ""
            let start, end
            invoice.invoice_rows.forEach(row => {
                row.items.forEach(item => {
                    // Collect days
                    const date = new Date(item.date)
                    if (!start || date.getTime() < start.getTime()) {
                        start = date
                    }
                    if (!end || date.getTime() > end.getTime()) {
                        end = date
                    }
                })
            })
            if (start && end) {
                range = this.$d(start, { dateStyle: 'short'}) + ' - ' + this.$d(end, { dateStyle: 'short'})
            }
            return range
        }
    }
}
